//auth 2.0
export function formatImageTime(seconds) {
  const timeString = [parseInt(seconds / 60 / 60), parseInt((seconds / 60) % 60), parseInt(seconds % 60)].join(":").replace(/\b(\d)\b/g, "0$1");
  if (seconds < 3600) {
    return timeString.replace(/^(?:00:)?/, "");
  }
  return timeString;
}